export enum NotebookKernelEntityType {
  KernelImage = 'KernelImage',
  KernelTemplate = 'KernelTemplate',
  KernelSpec = 'KernelSpec',
  NotebookImage = 'NotebookImage',
  SandboxImage = 'SandboxImage',
}
